// Whitelist approach: show Zendesk only on specified routes. Empty config = hide everywhere.

export interface ZendeskConfig {
  readonly suffixes: readonly string[]
  readonly exactRoutes: readonly string[]
  readonly prefixes: readonly string[]
}

export const shouldShowZendeskOnRoute = (pathname: string): boolean => {
  const hasSuffixMatch = SHOW_ZENDESK_CONFIG.suffixes.some((suffix) =>
    pathname.endsWith(`/${suffix}`),
  )
  if (hasSuffixMatch) {
    return true
  }

  const hasExactMatch = SHOW_ZENDESK_CONFIG.exactRoutes.some(
    (route) => pathname === route,
  )
  if (hasExactMatch) {
    return true
  }

  const hasPrefixMatch = SHOW_ZENDESK_CONFIG.prefixes.some((prefix) =>
    pathname.startsWith(prefix),
  )
  if (hasPrefixMatch) {
    return true
  }

  return false
}

export const SHOW_ZENDESK_CONFIG: ZendeskConfig = {
  suffixes: [],

  exactRoutes: [],

  prefixes: [],
} as const
